/* eslint-disable no-template-curly-in-string */
var es = {
    translation: {
        button: {
            backToAccountManager: "Regresar al Administrador de Cuenta",
        },
        labels: {
            title: "TODO",
        },
        errorPage: {
            title: "TODO",
            description: "Tenemos problemas para recuperar\nsu información",
            tryAgain: "Por favor, vuelva a intentarlo más tarde.",
            noCertificates: "No hay certificados que coincidan con ese número de certificado.\nPor favor verifique el número e inténtelo de nuevo.",
        },
        faqs: {
            faqLinkText: "Preguntas Frecuentes sobre Recompensas",
            description: "*Compras sujetas a aprobación de crédito. Consulte los <a>Términos del Programa de Recompensas</a> para obtener detalles.",
            hftDescription: "*Compras sujetas a aprobación de crédito.\n**Obtenga 5 puntos de recompensa por cada $1 que gaste en Harbor Freight. Consulte los <a>Términos del Programa de Recompensas</a> para obtener detalles.",
            jcrewFaqsSubHeader: "Vea su <a>Nivel de Estatus de Categoría de J.Crew y todos los beneficios para titulares de tarjetas</a>",
            virginDescription: "*Vea los <a>Términos de Recompensas de Crédito</a> para detalles.\n\nSi tiene una devolución en su Tarjeta de Virgin Red Rewards, es posible que vea puntos negativos en una o más categorías. Los nuevos puntos que obtenga con su tarjeta en esa categoría se aplicarán primero al saldo negativo de la misma categoría. Los puntos se añadirán a su Cuenta del Programa de Virgin Red Rewards una vez que su saldo de puntos dentro de esa categoría sea positivo.\n\nSynchrony Bank emite esta tarjeta conforme una licencia de MasterCard International Incorporated. Mastercard es una marca registrada, y el diseño de los círculos es una marca comercial de Mastercard International Incorporated. La marca de Indicador Sin Contacto, que consiste en cuatro arcos graduales, es una marca comercial propiedad de EMVCo, LLC y usada con su autorización.",
            cathayDescription: "*Compras sujetas a aprobación de crédito. Para obtener detalles, vea los <a>Términos del Programa de Recompensas</a>.\n\nSynchrony Bank emite esta tarjeta conforme una licencia de MasterCard International Incorporated. Mastercard es una marca registrada, y el diseño de los círculos es una marca comercial de Mastercard International Incorporated. La marca de Indicador Sin Contacto, que consiste en cuatro arcos graduales, es una marca comercial propiedad de EMVCo, LLC y usada con su autorización.",
        },
        certificateHistoryTab: {
            amount: "Monto del \nCertificado",
            certificate: "Certificado",
            status: "Estatus",
            certificateNumber: "Número de Certificado",
            date: "Fecha",
            searchCertNum: "Buscar el Número de Certificado",
            redeemed: "Canjeado",
            expired: "Expirado",
        },
        selectDropdown: {
            sortBy: "Organizar Por",
            newestDate: "Fecha - Más reciente",
            oldestDate: "Fecha - Más antigua",
            redeemedStatus: "Estatus - Canjeado",
            expiredStatus: "Estatus - Vencido",
            lowestAmount: "Monto - Más bajo",
            highestAmount: "Monto - Más alto",
        },
        fullDetailsPage: {
            certificateHistory: "Historial de Certificados",
            rewardsMilestones: "Hitos de Mis Recompensas",
            howToEarnPointsHeader: "Cómo obtener puntos",
            jCrewHowToEarnPointsHeader: "Cómo obtener puntos por compras en J.Crew y J.Crew Factory",
            virginHowToEarnPointsHeader: "Cómo obtener puntos*",
            cathayHowToEarnPointsHeader: "Cómo obtener Asia Miles",
            certificate: {
                expiringSoon: "CADUCA PRONTO",
                select: "SELECCIONE",
                useBy: "Usar antes del",
            },
            redemptionDisclaimer: "Canjee sus Certificados de Recompensas y pague cualquier saldo restante con su tarjeta de crédito TJX Rewards para obtener puntos para su próximo certificado.",
            removeTimeFromList: "Puede que se demore hasta 72 horas para ser removidos de esta lista.",
            rewards: "Recompensas",
            printCheckout: "Simplemente imprima o muestre los Certificados de Recompensas digitales al momento de pagar",
            useRewardsNow: "Canjee sus certificados de Recompensas",
            print: "imprimir",
            selectAll: "Seleccionar Todo",
            totalSavedYearRewards: "TOTAL AHORRADO ESTE AÑO EN RECOMPENSAS",
            totalPointsRedeemedYear: "PUNTOS TOTALES CANJEADOS ESTE AÑO",
            totalPointsEarnYear: "PUNTOS TOTALES OBTENIDOS ESTE AÑO",
            unSelectAll: "Deseleccionar Todos",
            myRewardsCertificates: "Mis Certificados de Recompensas",
            viewAllCertificates: "VER TODOS LOS CERTIFICADOS DE RECOMPENSAS",
            viewPrint: "VER/IMPRIMIR",
            viewRewardCertificates: "Ver certificados de recompensa",
        },
        cathayEarnings: {
            yourCathayEarnings: "Sus Cathay Asia Miles obtenidas",
        },
        jCrewEarnings: {
            earningsFromLastStatement: "Sus ganancias de su último estado de cuenta",
            noAdjustments: "Actualmente no hay ajustes en sus Recompensas J.Crew",
            yourJcrewEarnings: "Sus ganancias de la Tarjeta de Crédito J.Crew",
        },
        virginEarnings: {
            yourVirginEarnings: "Sus ganancias Virgin Red",
        },
        jcrew: {
            perks: {
                perksHeader: "Algunas ventajas especiales para los titulares de tarjetas",
                freeStandardShippingTitle: "ENVÍO GRATIS",
                freeStandardShippingDescription: "Envío estándar gratuito en J.Crew y J.Crew Factory",
                birthdaySurprisesTitle: "CUMPLEAÑOS",
                birthdaySurprisesDescription: "$25 para gastar en J.Crew y J.Crew Factory",
                bonusPointsDaysTitle: "ALTERACIONES ESTÁNDAR GRATUITAS",
                bonusPointsDaysDescription: "En productos de precio sin descuento en J.Crew",
            },
        },
        virgin: {
            perks: {
                perksHeader: "Algunos beneficios especiales para los titulares de tarjetas*",
                extraNightTitle: "OBTENGA UNA NOCHE ADICIONAL GRATIS",
                extraNightDescription: "Compre dos noches y obtenga una gratis de Virgin Hotels por año",
                flyAndEarnTitle: "VUELE CON NOSOTROS Y OBTENGA PUNTOS",
                flyAndEarnDescription: "Reciba 25 Puntos de Nivel por gastar $2,500 por mes, con un máximo de 50 por mes.",
                earnBonusPointsTitle: "OBTENGA PUNTOS EXTRA",
                earnBonusPointsDescription: "Obtenga 2,500 puntos adicionales por añadir hasta 4 Usuarios Autorizados.",
            },
        },
        mocks: {
            accountEnding: "Cuenta que termina en {{accountLast4}}",
            availableToSpend: "Disponible para gastar",
            cardAccountEnding: "Tarjeta para cuenta que termina en {{accountLast4}}",
            currentBalance: "Saldo Actual",
            environment: "Elige un entorno",
            makeAPayment: "Realizar un pago",
            paymentDueDate: "Fecha de vencimiento del pago",
            rewards: "RECOMPENSAS",
            totalMinimumPayment: "Pago Mínimo Total",
        },
        modal: {
            header: {
                text: "Descripción de las Recompensas",
            },
            footer: {
                closeButton: "Cerrar",
                rewardsButton: "VER LOS DETALLES COMPLETOS DE LAS RECOMPENSAS",
            },
            rewards: {
                currentPoints: "Puntos actuales",
                nextCertificate: "certificado de ${{amount}}",
                currentRewards: "Saldo actual del\nCertificado de Recompensas",
                progress: "Progreso de Mis Recompensas",
            },
        },
        shopMore: {
            jCrewEarnPoints: "Consulte nuestros beneficios especiales, solo para Titulares de Tarjetas",
            virginEarnPoints: "Consulte nuestros beneficios especiales solo para Titulares de Tarjetas",
            cathayButtonText: "Ir a Cathay Rewards",
            jCrewButtonText: "Ir a Recompensas J.Crew",
            virginButtonText: "Aprenda más",
            earnMoreRewards: "Gane más\nrecompensas",
            withYour: "con su",
            earnPoints: "Obtenga puntos para su próximo\ncertificado de recompensas y luego vuelva a consultar\naquí para canjearlos.",
            tjxEarnPoints: "Siga comprando con su tarjeta de crédito TJX Rewards para obtener puntos para su próximo Certificado de Recompensas. ¡Es la única forma de ahorrar aún más en sus tiendas favoritas!",
        },
        drawerHeader: {
            subtitle: {
                account: "Cuenta que termina en {{accountLast4}}",
            },
        },
        error: {
            uiComponent: "No disponible",
        },
        rewardsBanner: {
            altText: "banner de {{client}}",
        },
        viewPrintModal: {
            and: "y",
            atHomeViewPrint: "Los certificados se pueden utilizar en la tienda o en línea en",
            digitalCopy: "Esta es una copia digital del certificado que recibió con el extracto de su tarjeta de crédito.",
            issueDate: "Fecha de Emisión",
            presentPurchase: "*Presente al momento de la compra.",
            tjxDisclaimer: "No aceptado en Marshalls o HomeSense en Canadá.",
            tjxViewPrint: "Los certificados se pueden utilizar dentro de nuestra familia de tiendas o en línea en",
            hftViewPrint: "Los certificados se pueden utilizar dentro de nuestras tiendas o en línea en",
            redeemAt: "<p>Canjee en:</p>",
            rewardsCertificate: "Certificado de Recompensas",
            viewRewardCertificate: "Ver Certificados de Recompensas",
            viewRewardsProgram: "Consulte los <a>Términos del Programa de Recompensas</a> para obtener detalles",
        },
    },
};
export default es;
